import React from 'react';
import { Chart } from 'react-google-charts';

export const options = {
  title: 'Cursos mas vistos',
  is3D: true,
  backgroundColor: 'transparent',
  titleTextStyle: {
    color: '#FFFFFF',
    fontSize: 20,
  },
  legend: {
    textStyle: { color: '#FFFFFF', fontSize: 14 },
  },
  hAxis: {
    textStyle: { color: '#FFFFFF' },
    titleTextStyle: { color: '#FFFFFF' },
  },
  vAxis: {
    textStyle: { color: '#FFFFFF' },
    titleTextStyle: { color: '#FFFFFF' },
  },
  pieSliceTextStyle: {
    color: '#FFFFFF',
  },
};
export function GooglePieChart({ data }) {
  const tData = data &&
    data.length !== 0 && [['Curso', 'Valor'], ...data.map((item) => [item.name, item.value])];
  return (
    tData && (
      <Chart chartType="PieChart" data={tData} options={options} width={'100%'} height={'400px'} />
    )
  );
}
